module.exports = __webpack_public_path__ + "static/media/Vanstone Bailey.7f5b0148.svg";